import React from "react";
import FleetInternalLossesComparison from "./Charts/FleetInternalLossesComparison";
import FleetInternalLossesEvolution from "./Charts/FleetInternalLossesEvolution";
import FleetPerformanceEvolution from "./Charts/FleetPerformanceEvolution";
import EmptyReporting from "../EmptyReporting";
import { usePerformanceReporting } from "../../../../api/useReporting";

export const ReportingPerformance = () => {
  const reporting = usePerformanceReporting();

  if (!reporting.periods.length) return <EmptyReporting reporting={reporting} />;

  return (
    <>
      <FleetPerformanceEvolution reporting={reporting} />
      <FleetInternalLossesEvolution reporting={reporting} />
      <FleetInternalLossesComparison reporting={reporting} />
    </>
  );
};
